import { ApiRequestGet } from "../../data/network/services/ApiRequestGet";
import { SUCCESS } from "../../presentation/resources/constantsManager";
import { updateClientBalanceAction } from "../../data/redux/action/balanceAction";
import { numberWithCommas, RupeesToPaise } from "../commaSeperator";
export const formatBalance = (balance) => {
  return balance.toFixed(2).replace(/(\d)(?=(\d{2})+\d\.)/g, "$1,");
};

export const updateClientbalance = () => (dispatch) => {
  ApiRequestGet.getBalance()
    .then((res) => {
      if (res?.status === SUCCESS) {
        let rupee = res?.data?.balance;
        dispatch(
          updateClientBalanceAction({
            availableBalance: rupee,
          })
        );
      }
    })
    .catch((err) => {
      console.error(err, "huisfgusguf");
    });
};
